import { ProgressBar } from 'primereact/progressbar';
import './Progress.scss';
import React from 'react';
import { classNames } from 'primereact/utils';

type ProgressColor = 'primary' | 'success' | 'error' | 'warning' | null;

interface Props {
  value: number | null;
  showValue: boolean;
  color?: ProgressColor;
}

export const Progress = ({ value, color = 'primary', showValue }: Props) => {
  if (value === null || isNaN(value)) return null;

  const displayValue = Math.round(value);
  return (
    <div className={classNames('progress-container', color)}>
      {showValue && <p className='progress-value'>{displayValue}%</p>}
      <ProgressBar showValue={false} value={displayValue} />
    </div>
  );
};
